import React, { forwardRef, FC } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { parse, stringify } from 'query-string';
import { Tabs, Tab, AppBar } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    zIndex: 1,
  },
  tabs: {
    backgroundColor: theme.palette.common.white,
  },
  tab: {
    flex: 1,
  },
}));

interface TabLocation {
  pathname: string;
  search?: Record<string, string>;
}

interface TabRoute {
  label: string;
  location: TabLocation;
}

interface RoutingTabsProps {
  tabs: TabRoute[];
}

type myLinkProps = Omit<LinkProps, 'to'>;

export const RoutingTabs: FC<RoutingTabsProps> = ({ tabs }) => {
  const location = useLocation();
  const classes = useStyles();
  const parsedSearch = parse(location.search);
  const myLink = (tabLocation: TabLocation) =>
    forwardRef<myLinkProps, any>((props, ref) => (
      <Link
        to={{
          ...location,
          pathname: tabLocation.pathname,
          search: stringify({ ...parsedSearch, ...tabLocation.search }),
        }}
        {...props}
        ref={ref}
      />
    ));
  return (
    <AppBar position="static" classes={{ root: classes.wrapper }}>
      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        scrollButtons={false}
        classes={{ root: classes.tabs }}
      >
        {tabs.map(({ location: tabLocation, label }, i) => (
          <Tab
            className={classes.tab}
            component={myLink(tabLocation)}
            label={label}
            value={tabLocation.pathname}
            key={i}
          />
        ))}
      </Tabs>
    </AppBar>
  );
};
